import { faListRadio, faListTree } from "@fortawesome/pro-light-svg-icons"
import { faSearch } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { InputAdornment, TextField, Tooltip, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IForm } from "form/model"
import { setEnvironmentIsTreeView, setEnvironmentsFilters } from "form/tools/environments"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { SelectionFilter } from "../filter/SelectionFilter"

interface IContentEnvironmentsProps {
  isTreeView: boolean
  form: IForm
}

export const EnvironmentsFilter = React.memo(({ isTreeView, form }: IContentEnvironmentsProps): JSX.Element => {
  const descriptions: string[] = []
  if (isTreeView) {
    descriptions.push(translate("environments.tree.description"))
    descriptions.push(translate("environments.use.list.to.filter"))
  } else {
    // list view
    descriptions.push(translate("environments.list.description"))
    descriptions.push(translate("environments.use.tree.to.select"))
  }
  return (
    <FlexBox jc="space-between" wrap gap>
      <FlexBox vertical ai="start" jc="start">
        {descriptions.map((description, index) => (
          <Typography id={`environment-description-${index}`} color="textSecondary" fontSize=".85rem" key={index}>
            {description}
          </Typography>
        ))}
      </FlexBox>
      <FlexBox gap="2rem" wrap jc="end">
        {!isTreeView && (
          <FlexBox jc="start" wrap gap>
            <TextField
              id="environment-find"
              label={translate("label.find.environment")}
              value={form.screens.environmentFilter}
              onChange={event => setEnvironmentsFilters({ name: event.target.value })}
              size="small"
              sx={{ minWidth: "14rem", maxWidth: "14rem" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FontAwesomeIcon icon={faSearch} size="lg" />
                  </InputAdornment>
                )
              }}
            />
            <SelectionFilter
              id="environment-filter"
              value={form.screens.environmentSelectFilter}
              onChange={newSelectFilter => setEnvironmentsFilters({ selectFilter: newSelectFilter })}
              sx={{ minWidth: "14rem", maxWidth: "14rem" }}
            />
          </FlexBox>
        )}
        <FlexBox
          gap
          wrap
          sx={{
            "& .icon": {
              height: "1.4rem",
              p: ".6rem",
              borderRadius: "2rem",
              color: theme => theme.palette.specialText,
              backgroundColor: theme => theme.palette.text.disabled
            },
            "& .icon.active": {
              backgroundColor: theme => theme.palette.text.primary2
            },
            "& .icon:hover": {
              cursor: "pointer",
              backgroundColor: theme => theme.palette.action.active
            },
            "& .icon.active:hover": {
              cursor: "default",
              backgroundColor: theme => theme.palette.text.primary2
            }
          }}>
          <Tooltip title={translate(isTreeView ? "environments.view.tree.active" : "environments.view.switch.to.tree")}>
            <div>
              <FontAwesomeIcon
                id="environment-tree-view-button"
                icon={faListTree}
                className={`icon ${isTreeView ? "active" : ""}`}
                size="2x"
                onClick={() => {
                  if (isTreeView) {
                    return
                  }
                  setEnvironmentIsTreeView(form, true)
                }}
              />
            </div>
          </Tooltip>
          <Tooltip
            title={translate(!isTreeView ? "environments.view.list.active" : "environments.view.switch.to.list")}>
            <div>
              <FontAwesomeIcon
                id="environment-list-view-button"
                icon={faListRadio}
                size="2x"
                className={`icon ${!isTreeView ? "active" : ""}`}
                onClick={() => {
                  if (!isTreeView) {
                    return
                  }
                  setEnvironmentIsTreeView(form, false)
                }}
              />
            </div>
          </Tooltip>
        </FlexBox>
      </FlexBox>
    </FlexBox>
  )
})
